import { Component, inject, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { StoreResetService } from '@store/store-reset.util';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  tablerBuilding,
  tablerBuildings,
  tablerHomeDollar,
  tablerTicket,
  tablerUsers,
  tablerX
} from '@ng-icons/tabler-icons';
import { getInitials } from '@shared/functions';

@Component({
  selector: 'app-sidenav',
  imports: [TranslocoModule, NgIcon, RouterLink, RouterLinkActive],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.css',
  providers: [
    provideIcons({
      tablerBuilding,
      tablerX,
      tablerTicket,
      tablerUsers,
      tablerHomeDollar,
      tablerBuildings
    }),
  ],
})
export class SidenavComponent {
  @Input() name = '';
  @Input() role = '';
  @Input() url: string | null = null;
  @Input() closeSidenav: () => void = () => { return; };

  private readonly storeResetService = inject(StoreResetService);

  get initials() {
    return getInitials(this.name);
  }

  onNavigate() {
    this.storeResetService.resetAllSelections();
    this.closeSidenav();
  }
}
